
import { defineComponent } from 'vue'
import { useThemeModel } from '@entities/theme'

export default defineComponent({
  name: 'WaitingDiscountModal',

  setup () {
    const themeModel = useThemeModel()

    return {
      themeModel
    }
  }
})
